import { SVGProps } from "react";
import styles from "../variants/01/sw-categories-variant-01.module.scss";

export const CategoryConvertibleSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 815.9 248.8"
    style={{
      // @ts-ignore
      enableBackground: "new 0 0 815.9 248.8",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path
      className={styles.st0}
      d="M176.3 146c23.1 0 41.9 18.8 41.9 41.9s-18.8 41.9-41.9 41.9-41.9-18.8-41.9-41.9 18.9-41.9 41.9-41.9m0-19c-33.6 0-60.9 27.3-60.9 60.9s27.3 60.9 60.9 60.9 60.9-27.3 60.9-60.9S210 127 176.3 127zM690.9 146c23.1 0 41.9 18.8 41.9 41.9s-18.8 41.9-41.9 41.9S649 211 649 187.9s18.8-41.9 41.9-41.9m0-19c-33.6 0-60.9 27.3-60.9 60.9s27.3 60.9 60.9 60.9 60.9-27.3 60.9-60.9-27.3-60.9-60.9-60.9z"
    />
    <path
      className={styles.st0}
      d="m815.4 193.8-6.6-18c-1.4-3.9-1.9-8.1-1.3-12.2l2.7-19.4c.5-3.5-.5-7.2-2.8-9.9-24-29.1-62.2-49.1-113.6-59.4-41.2-8.3-80.3-8.1-99.9-7.3-7.7.3-15.4-1.3-22.2-4.9L450.6.8c-3.4-1.7-7.6-.7-9.8 2.4L437 8.6c-1.3 1.8-1.7 4-1.2 6.2.5 2.1 1.9 4 3.8 5l88 49.1-328.1-16c-3.2-.2-6.2-1.1-8.9-2.8L168 35.6c-4.7-3-10.5-3.9-16-2.3L25.9 70.1c-6 1.8-10.2 7.4-10.1 13.7l.4 25.3c0 2.3-.7 4.5-2 6.3L2.8 130.6C1 133 0 136.1 0 139.1V160c0 27.2 22.1 49.3 49.3 49.3H109c-.5-1.6-1-3.3-1.4-5-1.3-5.3-1.9-10.8-1.9-16.4 0-38.9 31.7-70.6 70.6-70.6 38.9 0 70.6 31.7 70.6 70.6 0 5.7-.7 11.2-1.9 16.4-.4 1.7-.9 3.4-1.4 5h379.9c-.5-1.6-1-3.3-1.4-5-1.3-5.3-1.9-10.8-1.9-16.4 0-38.9 31.7-70.6 70.6-70.6 39 0 70.6 31.7 70.6 70.6 0 5.7-.7 11.2-1.9 16.4-.4 1.7-.9 3.4-1.4 5H763.3c30.2-.1 47.6-3.6 51.5-10.3 1.4-2 1.2-4 .6-5.2zm-4.9 2.9c-1.3 1.8-8.5 7.3-45.8 7.6 1.2-5.3 1.8-10.8 1.8-16.4 0-41.7-33.9-75.6-75.6-75.6-41.7 0-75.6 33.9-75.6 75.6 0 5.6.6 11.1 1.8 16.4H250.2c1.2-5.3 1.8-10.8 1.8-16.4 0-41.7-33.9-75.6-75.6-75.6s-75.6 33.9-75.6 75.6c0 5.6.6 11.1 1.8 16.4H49.3C24.9 204.3 5 184.4 5 160v-20.9c0-2 .7-4 1.8-5.6l11.3-15.1c2-2.7 3.1-6 3-9.4l-.4-25.3c-.1-4.1 2.6-7.7 6.5-8.8L153.4 38c1.3-.4 2.7-.6 4-.6 2.7 0 5.5.8 7.8 2.3l22.6 14.5c3.4 2.2 7.3 3.4 11.3 3.6l336.7 16.5c1.4.1 2.6-.8 3-2.2.4-1.3-.2-2.7-1.4-3.4L442 15.5c-.7-.4-1.2-1-1.3-1.8-.2-.8 0-1.5.4-2.2l3.8-5.4c.8-1.1 2.3-1.5 3.5-.9l121.1 61.9c7.6 3.9 16.2 5.8 24.8 5.4 35.3-1.5 154.7-1.4 209.4 64.9 1.4 1.7 2 3.9 1.7 6l-2.7 19.4c-.7 4.9-.1 9.9 1.6 14.6l6.7 18.2.1.2c-.2.2-.3.5-.6.9z"
    />
    <path
      className={styles.st0}
      d="M308.1 92.5h-25.6c-2.7 0-5-2.2-5-5 0-2.7 2.2-5 5-5h25.6c2.7 0 5 2.2 5 5s-2.3 5-5 5z"
    />
  </svg>
);
